import { IIdsRequest } from "../../model/request/IIdsRequest";
import { IGiaiDoan } from "../../model/respone/ke-hoach/IGiaiDoan";
import { apiClient } from "../apiClient";

export const GIAI_DOAN_API = "giai-doan";
export const giaiDoanApi = {
  SelectAll: () => apiClient.get(`${GIAI_DOAN_API}`),
  SelectByNamHoc: (nam_hoc:string) => apiClient.get(`${GIAI_DOAN_API}?nam_hoc=${nam_hoc}`),
  Insert: (payload: IGiaiDoan) => apiClient.post(`${GIAI_DOAN_API}`, payload),
  Update: (payload: IGiaiDoan) => apiClient.put(`${GIAI_DOAN_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${GIAI_DOAN_API}/${id}`),
  Deletes: (payload:IIdsRequest) => apiClient.put(`${GIAI_DOAN_API}/deletes`, payload),
};
